import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSearchParams } from '../components/helpers';
import { startSearchResults } from '../firebase/venues';
import { getIsFetching, setIsFetching, setSearchResults } from '../store/search';

import Loading from '../components/Loading';
import SearchVenues from '../components/SearchVenues';
import { useAbandonedBookingTag } from '../tag-manager/booking.tag';

const PageSearchVenues = () => {
  const { location, guests: numGuests, start: startDate, end: endDate } = useSearchParams();
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);

  useLayoutEffect(() => {
    const bookingData = localStorage.getItem('booking_status');

    if (bookingData) {
      try {
        const { venueName, label, timestamp } = JSON.parse(bookingData);

        // Opcional: puedes validar antigüedad (ej. solo si fue hace menos de 30 mins)
        const bookingTime = new Date(timestamp);
        const now = new Date();
        const diffInMinutes = (now - bookingTime) / (1000 * 60);
        if (diffInMinutes < 30) {
          useAbandonedBookingTag({ label, venueName });
        }
      } catch (err) {
        console.error('Invalid booking_status format in localStorage', err);
      }

      // Limpia para que no se dispare de nuevo en futuros renders
      localStorage.removeItem('booking_status');
    }

    startSearchResults({
      setFetching(value) {
        dispatch(setIsFetching(value));
      },
      setSearchResults(results) {
        dispatch(setSearchResults(results));
      },
      location,
      numGuests,
      startDate,
      endDate
    });
  }, [location, numGuests, startDate, endDate]);

  if (isFetching) {
    return <Loading />;
  }

  return <SearchVenues />;
};

export default PageSearchVenues;
